module.exports = __webpack_public_path__ + "img/type_of_word.d3346e97.svg";